import { useContext, useMemo } from "react";
import { LocationContext } from "context/Location";
import { useAuth } from "hooks/useAuth";

export const VISITSTART_ADMIN_GOVERNOR = "visitstart_admin_governor";
export const VISITSTART_REGISTRATION_ADMIN = "visitstart_registration_admin";
export const VISITSTART_REGISTRATION_CLINICAL =
  "visitstart_registration_clinical";

function holdersOf(facilityRoles, roleType) {
  const roles = facilityRoles && typeof facilityRoles === "object" ? facilityRoles : {};
  return Array.isArray(roles[roleType]) ? roles[roleType] : [];
}

/**
 * VisitStart facilityRoles annotations on the caller's current location.
 * Additive grants on top of users.role (typically facility / professional).
 */
export function useVisitStartFacilityRoles() {
  const { location } = useContext(LocationContext) || {};
  const { user } = useAuth();
  const uid = user?.uid;

  return useMemo(() => {
    const roles = location?.facilityRoles || {};
    const has = (roleType) => Boolean(uid) && holdersOf(roles, roleType).includes(uid);
    return {
      isAdminGovernor: has(VISITSTART_ADMIN_GOVERNOR),
      isRegistrationAdmin: has(VISITSTART_REGISTRATION_ADMIN),
      isRegistrationClinical: has(VISITSTART_REGISTRATION_CLINICAL),
    };
  }, [location?.facilityRoles, uid]);
}
